import { useContext, useState, useEffect } from "react";
import { Store } from "../Store";
import { Toolbar, Box, Typography, Button, Stack, IconButton, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import axios from "axios";

const Header = () => {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  const signoutHandler = () => {
    ctxDispatch({ type: "USER_SIGNOUT" });
    localStorage.removeItem("userInfo");
    window.location.href = "/login";
  };

  const [projectsAnchorEl, setProjectsAnchorEl] = useState(null);
  const [mobileAnchorEl, setMobileAnchorEl] = useState(null);
  const [categories, setCategories] = useState([]);

  const projectsOpen = Boolean(projectsAnchorEl);
  const mobileOpen = Boolean(mobileAnchorEl);

  const handleProjectsClick = (event) => {
    setProjectsAnchorEl(event.currentTarget);
  };

  const handleProjectsClose = () => {
    setProjectsAnchorEl(null);
  };

  const handleMobileClick = (event) => {
    setMobileAnchorEl(event.currentTarget);
  };

  const handleMobileClose = () => {
    setMobileAnchorEl(null);
  };

  const getCategories = async () => {
    try {
      const res = await axios.get(
        "https://api.aghayev-marjanscy.pl/api/projects/categories"
      );
      setCategories(res.data.categories || []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <Toolbar
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: 80,
        px: { xs: 2, md: 4 },
      }}
    >
      <Link to="/" style={{ textDecoration: "none" }}>
        <Box
          component="img"
          src="/logo_final.svg"
          alt="Marjanscy"
          sx={{
            height: { xs: 52, sm: 64, md: 80 },
            display: "block",
          }}
        />
      </Link>

      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{
          display: { xs: "none", md: "flex" },
        }}
      >
        {userInfo && userInfo.isAdmin && (
          <Link to="/projects/add" style={{ textDecoration: "none" }}>
            <Button sx={{ color: "#000" }}>Dodaj Projekt</Button>
          </Link>
        )}

        {!userInfo && (
          <Link to="/login" style={{ textDecoration: "none", color: "black" }}>
            <Typography variant="h6" color="white">Z</Typography>
          </Link>
        )}

        {userInfo && (
          <Button onClick={signoutHandler} sx={{ color: "#000" }}>
            Wyloguj
          </Button>
        )}

        <Button onClick={handleProjectsClick} sx={{ color: "#000" }}>
          Projekty
        </Button>

        <Link to="/aboutus" style={{ textDecoration: "none" }}>
          <Button sx={{ color: "#000" }}>O nas</Button>
        </Link>

        <Link to="/contact" style={{ textDecoration: "none" }}>
          <Button sx={{ color: "#000" }}>Kontakt</Button>
        </Link>
      </Stack>

      {/* MOBILE MENU BUTTON */}
      <Box sx={{ display: { xs: "flex", md: "none" } }}>
        <IconButton onClick={handleMobileClick}>
          <MenuIcon />
        </IconButton>
      </Box>

      {/* PROJECTS MENU - DESKTOP */}
      <Menu
        anchorEl={projectsAnchorEl}
        open={projectsOpen}
        onClose={handleProjectsClose}
      >
        <Link to="/" style={{ textDecoration: "none", color: "black" }}>
          <MenuItem onClick={handleProjectsClose}>Wszystkie</MenuItem>
        </Link>

        {categories.map((category) => (
          <Link
            to={`/search?category=${category}`}
            style={{ textDecoration: "none", color: "black" }}
            key={category}
          >
            <MenuItem onClick={handleProjectsClose}>{category}</MenuItem>
          </Link>
        ))}
      </Menu>

      {/* MOBILE MENU */}
      <Menu
        anchorEl={mobileAnchorEl}
        open={mobileOpen}
        onClose={handleMobileClose}
      >
        {userInfo && (
          <MenuItem
            onClick={() => {
              handleMobileClose();
              signoutHandler();
            }}
          >
            Wyloguj
          </MenuItem>
        )}

        <MenuItem
          onClick={(e) => {
            handleMobileClose();
            handleProjectsClick(e);
          }}
        >
          Projekty
        </MenuItem>

        <Link
          to="/aboutus"
          style={{ textDecoration: "none", color: "black" }}
        >
          <MenuItem onClick={handleMobileClose}>O nas</MenuItem>
        </Link>

        <Link
          to="/contact"
          style={{ textDecoration: "none", color: "black" }}
        >
          <MenuItem onClick={handleMobileClose}>Kontakt</MenuItem>
        </Link>
      </Menu>
    </Toolbar>
  );
};

export default Header;
